export const computeWorkTime = (contractInfo) => contractInfo ?
    contractInfo.mondayWorkLoad +
    contractInfo.tuesdayWorkLoad +
    contractInfo.wednesdayWorkLoad +
    contractInfo.thursdayWorkLoad +
    contractInfo.fridayWorkLoad +
    contractInfo.saturdayWorkLoad +
    contractInfo.sundayWorkLoad
    : null;

// Returns the workload when using Date.prototype.getDay()
// watch out: getDay() assumes start of week on Sunday (day 0)
export const workLoadForDay = (contractInfo, day) => [
    contractInfo.sundayWorkLoad,
    contractInfo.mondayWorkLoad,
    contractInfo.tuesdayWorkLoad,
    contractInfo.wednesdayWorkLoad,
    contractInfo.thursdayWorkLoad,
    contractInfo.fridayWorkLoad,
    contractInfo.saturdayWorkLoad,
][day];
